import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_InitialCrisisIntervention = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_InitialCrisisIntervention' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>When complete, please fax to 1-855-301-5356. You may also
                    call in the initial crisis intervention notification to
                    1-855-285-7466.
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>Following notification of an initial crisis intervention,
                    an authorization number will be provided to the provider
                    within two business days of receipt of request. All
                    out-of-network provider requests will be reviewed for
                    medical necessity of services.
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>Please print clearly — incomplete or illegible forms
                    will delay processing.
                </p>

                <p className='w-750'><h3>Member Information</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Who referred the member for initial crisis intervention service:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhoReferred_1' name='cbWhoReferred_1' className='add-only' value='1' />
                            Member/parent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhoReferred_2' name='cbWhoReferred_2' className='add-only' value='1' />
                            PCP
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhoReferred_3' name='cbWhoReferred_3' className='add-only' value='1' />
                            School
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWhoReferred_4' name='cbWhoReferred_4' className='add-only' value='1' />
                            Therapist/psychiatrist
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWhoReferred_5' name='cbWhoReferred_5' className='add-only' value='1' />
                            State agency: &nbsp;
                            <input type='text' id='txtWhoReferred_5' name='txtWhoReferred_5' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWhoReferred_6' name='cbWhoReferred_6' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtWhoReferred_6' name='txtWhoReferred_6' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Member Primary Diagnosis</span>
                            <input type='text' id='txtDx' name='txtDx' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Provider Information</h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name</span>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>NPI Number</span>
                            <input type='text' id='txtNPI' name='txtNPI' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Group/agency name</span>
                            <input type='text' id='txtGroupName' name='txtGroupName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Physical address</span>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Fax</span>
                            <input type='text' id='txtFax' name='txtFax' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The provider is</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProviderIs_1' name='cbProviderIs_1' className='add-only' value='1' />
                            In network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProviderIs_2' name='cbProviderIs_2' className='add-only' value='1' />
                            Out of network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProviderIs_3' name='cbProviderIs_3' className='add-only' value='1' />
                            In credentialing process
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Provider Credentials</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProvCred_1' name='cbProvCred_1' className='add-only' value='1' />
                            M.D.
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProvCred_2' name='cbProvCred_2' className='add-only' value='1' />
                            PH.D.
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProvCred_3' name='cbProvCred_3' className='add-only' value='1' />
                            L.M.H.P
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProvCred_4' name='cbProvCred_4' className='add-only' value='1' />
                            Bachelor's level
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProvCred_5' name='cbProvCred_5' className='add-only' value='1' />
                            N.P.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProvCred_6' name='cbProvCred_6' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtProvCred_6' name='txtProvCred_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider contact name</span>
                            <input type='text' id='txtProviderContact' name='txtProviderContact' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>Please note: Prior authorization is required for all crisis intervention follow-up services. Providers can also submit a notification
                    of initial crisis intervention services via the AmeriHealth Caritas Louisiana NaviNet provider portal and obtain an authorization
                    number at time of submission, as well as call into our Behavioral Health Utilization Management at 1-855-285-7466.
                </p>


                <p className='w-750'><h3>Service Information</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>All participants in the session</span>
                    <textarea id='txtAllParticipants' name='txtAllParticipants' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Summary of the crisis/symptoms and interventions completed</span>
                    <textarea id='txtSummary' name='txtSummary' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Outcome of the Session</span>
                    <input type='checkbox' id='cbOutcome_1' name='cbOutcome_1' className='add-only' value='1' />
                    Member stabilized and returned home with supports.<br />
                    <input type='checkbox' id='cbOutcome_2' name='cbOutcome_2' className='add-only' value='1' />
                    Member taken to ER for possible inpatient admission<br />
                    <input type='checkbox' id='cbOutcome_3' name='cbOutcome_3' className='add-only' value='1' />
                    Other:<br />
                    <textarea id='txtOutcome_3' name='txtOutcome_3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Patient status at end of services</span>
                    <textarea id='txtPatientStatus' name='txtPatientStatus' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Planned follow up of crisis intervention</span>
                    <textarea id='txtFollowUp' name='txtFollowUp' className='add-only'></textarea>
                </p>

                <p className='w-750'>I certify that I have received crisis intervention services. I understand payment will be from federal, state, and local funds.
                    These are sometimes called public funds. I also understand that if I conceal facts or make false claims, statements, or
                    documents, I may be prosecuted. By signing below, I agree that I (or my child) have received these services.
                </p>

                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Member/legal guardian signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <input type='checkbox' id='cbSigned_1' name='cbSigned_1' className='add-only' value='1' />
                    Member and/or legal guardian declined<br />
                    <input type='checkbox' id='cbSigned_2' name='cbSigned_2' className='add-only' value='1' />
                    Member and/or legal guardian unable to sign the encounter form due to:
                    <input type='text' id='txtSigned_2' name='txtSigned_2' className='add-only w-350 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Provider signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>

                <p className='w-750'>Please note: Prior authorization is required for all crisis intervention follow-up services. Providers can also submit a notification
                    of initial crisis intervention services via the AmeriHealth Caritas Louisiana NaviNet provider portal and obtain an authorization
                    number at time of submission, as well as call into our Behavioral Health Utilization Management at 1-855-285-7466.
                </p>


            </div>
        </form >

    )
}











